export default __webpack_public_path__ + "static/media/ico_alert1.807197cb.svg";